import Splide from '@splidejs/splide';

const reviews = document.querySelector('.js-Reviews')
const reviews_more = document.querySelectorAll('.js-Reviews-More')


if(reviews){
  new Splide(reviews, {
    perPage: 1,
    gap: 20,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 2,
        gap: 40,
        padding: { left: 50, right: 50},
      },
      1200: {
        perPage: 3,
        gap: 40,
        padding: { left: 100, right: 100},
      },
    }
  }).mount();

  reviews_more.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const parent = e.currentTarget.closest('.reviews__item')
      parent.classList.add('is-open')

      e.preventDefault()
    })
  })
}
